export default __webpack_public_path__ + "static/media/calendar.2f58c7e5.svg";